module.exports = __webpack_public_path__ + "static/img/p4.db8fb13.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p4.png
// module id = BgE7
// module chunks = 1